const MIN_LOADING_DURATION = 180;

export default defineNuxtPlugin(nuxtApp => {
	const router = nuxtApp.$router as
		| {
				beforeEach?: (guard: (to: any, from: any) => void) => void;
				onError?: (handler: () => void) => void;
		  }
		| undefined;
	if (!router?.beforeEach) return;

	let hideTimer: ReturnType<typeof setTimeout> | null = null;

	const clearHideTimer = () => {
		if (!hideTimer) return;
		clearTimeout(hideTimer);
		hideTimer = null;
	};

	const scheduleHide = () => {
		const state = useRouteLoadingSkeletonState();
		if (!state.value.active) return;

		clearHideTimer();
		const elapsed = Date.now() - state.value.startedAt;
		const delay = Math.max(MIN_LOADING_DURATION - elapsed, 0);

		hideTimer = setTimeout(() => {
			hideRouteLoadingSkeleton();
			hideTimer = null;
		}, delay);
	};

	router.beforeEach((to, from) => {
		clearHideTimer();

		if (to.fullPath === from.fullPath) {
			hideRouteLoadingSkeleton();
			return;
		}

		const skeletonKey = resolveRouteLoadingSkeleton(to);
		if (!skeletonKey) {
			hideRouteLoadingSkeleton();
			return;
		}

		showRouteLoadingSkeleton(skeletonKey);
	});

	nuxtApp.hook('page:loading:end', () => {
		scheduleHide();
	});

	nuxtApp.hook('page:finish', () => {
		scheduleHide();
	});

	router.onError?.(() => {
		clearHideTimer();
		hideRouteLoadingSkeleton();
	});
});
